import Index from "./Pages";

function App() {
  return <Index />;
}

export default App;
